//
//
//
//
//
//

export default {
    props: {
        tight: Boolean,
        horizontal: Boolean,
    },

    methods: {
        getScrollTarget(...args) {
            return this.$refs.scroll.getScrollTarget(...args);
        },
        getScrollPosition(...args) {
            return this.$refs.scroll.getScrollPosition(...args);
        },
        setScrollPosition(...args) {
            return this.$refs.scroll.setScrollPosition(...args);
        },
    },
};
